<template>
  <div class="product">
    <div class="left-nav">
      <el-collapse v-model="activeName" accordion @change="handleCollapse">
        <el-collapse-item
          :title="collapse.indexName"
          :name="collapse.indexOrder"
          v-for="collapse in navList"
          :key="collapse.id"
        >
          <el-tabs v-model="active" tab-position="left" @tab-click="handleLeftTabClick">
            <el-tab-pane
              :label="tab.indexName"
              :name="tab.id"
              v-for="tab in collapse.list"
              :key="tab.id"
              :disabled="tab.indexName == '申万行业高频模拟和预测库'"
            ></el-tab-pane>
          </el-tabs>
        </el-collapse-item>
      </el-collapse>
    </div>
    <div class="right-content">
      <overview-macro v-if="active == '212'"></overview-macro>
      <overview-capital v-if="active == '213'"></overview-capital>
      <overview-company v-if="active == '214'"></overview-company>
      <overview-area v-if="active == '215'"></overview-area>
      <overview-green v-if="active == '221'"></overview-green>
      <news v-if="active == '216'"></news>
      <div v-if="active == '217'">
        <div class="predict">
          <img class="logo" src="../../assets/img/qyc.png" alt />
          <div class="sub-title">看上游、看自身、看下游，就上腾景“企预测”</div>
          <div class="input-wrap">
            <el-input placeholder="请输入企业名称" v-model="companyName">
              <template slot="append">
                <span @click="submit">查询</span>
              </template>
            </el-input>
          </div>
        </div>
      </div>
      <div v-else class="index-content">
        <el-tabs v-model="activeIndex" @tab-click="handleClick">
          <el-tab-pane :label="tab.indexName" :name="tab.id" v-for="tab in rightTabs" :key="tab.id"></el-tab-pane>
        </el-tabs>
        <el-tabs style="margin-top:18px" v-model="secondActiveIndex" @tab-click="handleSecondClick">
          <el-tab-pane :label="tab.indexName" :name="tab.id" v-for="tab in secondTab" :key="tab.id"></el-tab-pane>
        </el-tabs>
        <div class="chart-wrap" v-if="indexLines.length">
          <div
            class="chart-item"
            :style="{width:(100/lineSize)+'%'}"
            v-for="line in indexLines"
            :key="line.id"
          >
            <div class="chart">
              <div class="title">{{line.indexName}}</div>
              <div class="line-chart">
                <line-chart
                  :noShadow="noShadow"
                  @showDialog="handleShowDialog"
                  :indexId="line.id"
                  :indexName="line.indexName"
                ></line-chart>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      custom-class="product-dialog"
      :show-close="true"
      :visible.sync="productdDialog"
      :close-on-click-modal="false"
      width="65%"
    >
      <product v-if="productdDialog" @showDialog="handleShowDialog" :productData="productData"></product>
    </el-dialog>
    <el-dialog
      custom-class="cashier-dialog"
      :show-close="true"
      :visible.sync="cashierDialog"
      :close-on-click-modal="false"
      width="50%"
    >
      <cashier
        v-if="cashierDialog"
        @showDialog="handleShowDialog"
        :cashierData="cashierData"
        @orderResult="handleOrderResult"
      ></cashier>
    </el-dialog>
    <el-dialog
      title
      :visible.sync="payResultDialog"
      custom-class="res-dialog"
      :close-on-click-modal="false"
      :modal-append-to-body="false"
      @closed="handleClosed"
      :show-close="true"
    >
      <pay-result v-if="payResultDialog" @showDialog="handleShowDialog" :jumpUrl="jumpUrl"></pay-result>
    </el-dialog>
    <el-dialog
      title
      :visible.sync="orderDialog"
      custom-class="order-dialog"
      :close-on-click-modal="false"
      :modal-append-to-body="false"
      :show-close="true"
    >
      <order-detail
        v-if="orderDialog"
        :visible="orderDialog"
        :orderNo="orderNo"
        @showDialog="handleShowDialog"
      ></order-detail>
    </el-dialog>
    <el-dialog
      title
      :visible.sync="invoiceDialog"
      custom-class="invoice-dialog"
      :close-on-click-modal="false"
      :modal-append-to-body="false"
    >
      <invoice v-if="invoiceDialog" @hideInvoiceDialog="handleHideInvoiceDialog" :orderNo="orderNo"></invoice>
    </el-dialog>
    <el-dialog
      title
      :visible.sync="errorDialog"
      custom-class="res-dialog"
      :close-on-click-modal="false"
      :modal-append-to-body="false"
    >
      <pay-error v-if="errorDialog"></pay-error>
    </el-dialog>
  </div>
</template>
<script>
import { findIndexRoot, findIndexStructure, queryByType } from "@/api/product";
import overviewCapital from "./overviewCapital.vue";
import overviewCompany from "./overviewCompany.vue";
import overviewMacro from "./overviewMacro.vue";
import overviewArea from "./overviewArea.vue";
import overviewGreen from "./overviewGreen.vue";
import product from "./components/product.vue";
import cashier from "./components/cashier.vue";
import payResult from "./components/payResult.vue";
import orderDetail from "./components/orderDetail.vue";
import payError from "./components/payError.vue";
import invoice from "./components/invoice.vue";
import news from "./news.vue";
import lineChart from "./lineChart.vue";
import mixin from "@/utils/mixins.js";
import { mapState } from "vuex";
export default {
  mixins: [mixin],
  data() {
    return {
      activeName: "1",
      active: "212",
      navList: [],
      activeIndex: "", // 右侧tab
      rightTabs: [],
      indexLines: [],
      secondActiveIndex: "",
      secondTab: [],
      lineSize: 4,
      noShadow: false,
      companyName: "",
      goodsSubType: "",
      productData: "",
      cashierData: "",
      productdDialog: false,
      cashierDialog: false,
      payResultDialog: false,
      orderDialog: false,
      invoiceDialog: false,
      errorDialog: false,
      jumpUrl: "",
      orderNo: ""
    };
  },
  computed: {
    ...mapState(["authorization"])
  },
  watch: {
    active(val) {
      // 宏观和行业全口径数据库 没有阴影
      if (val == 7) {
        this.noShadow = true;
      } else {
        this.noShadow = false;
      }
      this.handleFindIndexStructure();
    },
    $route() {
      if (this.$route.query.system) {
        this.handleFindIndexRoot();
      }
    }
  },
  components: {
    overviewCapital,
    overviewCompany,
    overviewMacro,
    lineChart,
    news,
    product,
    cashier,
    payResult,
    orderDetail,
    invoice,
    payError,
    overviewArea,
    overviewGreen
  },
  created() {
    this.handleFindIndexRoot();
  },
  methods: {
    submit() {
      this.goCompany();
    },
    async handleFindIndexRoot() {
      this.indexLines = [];
      this.secondTab = [];
      let { data } = await findIndexRoot();
      this.navList = data.resultBody;
      if (this.$route.query.system) {
        // 企预测
        this.activeName = this.$route.query.system;
        let arr = this.navList.filter(i => i.indexOrder == this.activeName);
        if (this.$route.query.system == "4" && !this.$route.query.id) {
          this.active = arr[0].list[0].id;
          this.goodsSubType = arr[0].list[0].indexName;
        } else {
          // this.active = arr[0].list[0].id;
          let newArr = arr[0].list.filter(
            item => item.indexName == this.$route.query.id
          )[0];
          this.active = newArr.id;
          this.goodsSubType = newArr.indexName;
        }
      }
      this.handleFindIndexStructure();
    },
    handleCollapse(val) {
      this.indexLines = [];
      this.secondTab = [];
      if (val) {
        let arr = this.navList.filter(i => i.indexOrder == val);
        this.active = arr[0].list[0].id;
      }
    },
    async handleFindIndexStructure() {
      let { data } = await findIndexStructure({
        systemId: this.active
      });
      this.rightTabs = data.resultBody;
      if (this.rightTabs) {
        this.activeIndex = this.rightTabs[0].id;
        this.indexLines = this.rightTabs[0].indexList;
        this.lineSize = this.rightTabs[0].lineSize;
      }
    },
    handleClick(val) {
      this.indexLines = [];
      this.secondTab = [];
      let arr = this.rightTabs.filter(i => i.id == val.name);
      // 存在二级
      if (arr[0].nextList) {
        this.secondTab = arr[0].nextList;
        // 默认激活
        this.secondActiveIndex = this.secondTab[0].id;
        this.indexLines = arr[0].nextList[0].indexList;
      } else {
        this.secondTab = [];
        this.indexLines = arr[0].indexList;
      }
      this.lineSize = arr[0].lineSize;
    },
    handleSecondClick(val) {
      this.indexLines = [];
      let arr = this.secondTab.filter(i => i.id == val.name);
      this.indexLines = arr[0].indexList;
    },
    handleLeftTabClick(val) {
      this.indexLines = [];
      this.secondTab = [];
      this.goodsSubType = val.label;
    },
    handleShowDialog(val) {
      if (val == 1) {
        this.handleQueryByType();
      } else if (val == 2) {
        this.productdDialog = false;
        this.cashierDialog = true;
      } else if (val == 3) {
        this.cashierDialog = false;
        this.payResultDialog = true;
      } else if (val == 4) {
        this.payResultDialog = false;
        this.orderDialog = true;
      } else if (val == 5) {
        this.orderDialog = false;
        this.invoiceDialog = true;
      } else if (val == 6) {
        this.productdDialog = false;
        this.errorDialog = true;
      }
    },
    async handleQueryByType() {
      let { data } = await queryByType({
        goodsType: "官网商品",
        goodsSubType: this.goodsSubType
      });
      if (data.resultBody) {
        this.productData = data.resultBody[0].list[0].list[0];
        this.jumpUrl = this.productData.jumpUrl;
        this.cashierData = data.resultBody[0].list[0];
        this.productdDialog = true;
      } else {
        this.productdDialog = false;
      }
    },
    handleOrderResult(val) {
      this.orderNo = val.orderNo;
    },
    handleClosed() {
      // 点击关闭重新加载线图数据
      this.indexLines = [];
      this.handleFindIndexStructure();
    },
    handleHideInvoiceDialog() {
      this.invoiceDialog = false;
    }
  }
};
</script>
<style lang="scss" scoped>
.product {
  height: 100%;
  display: flex;
  .left-nav {
    height: 100%;
    width: 280px;
    background: #fff;
    /deep/ .el-tabs__item.is-active {
      background: #ffe8de;
    }
    /deep/ .el-collapse-item__content {
      padding-bottom: 0;
    }
    /deep/ .el-collapse-item {
      .el-collapse-item__header {
        font-size: 18px;
        color: #828282;
        padding-left: 20px;
      }
    }
  }
  .right-content {
    flex: 1;
    .index-content {
      margin: 20px 0 0 20px;
      padding: 20px;
      background: #fff;
      border-radius: 10px;
      .chart-wrap {
        display: flex;
        flex-wrap: wrap;
        .chart-item {
          padding: 10px;
          box-sizing: border-box;
          .chart {
            border: 1px solid #c9c9c9;
            height: 190px;
            padding: 10px;
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
            .line-chart {
              flex: 1;
            }
          }
        }
      }
      /deep/ .el-tabs__item {
        padding-left: 0 !important;
        height: 42px !important;
      }
    }
    .predict {
      padding: 40px 20px;
      text-align: center;
      background: #fff;
      height: 100%;
      margin: 20px 0 0 20px;
      border-radius: 10px;
      padding-bottom: 400px;
      .logo {
        height: 46px;
        width: auto;
        margin-top: 120px;
      }
      .sub-title {
        font-size: 20px;
        color: #000;
        text-align: center;
        margin-top: 60px;
        margin-bottom: 24px;
      }
      .input-wrap {
        margin: 0 auto;
        width: 80%;
        /deep/ .el-input-group__append {
          background-color: #ff8e5c;
          color: #fff;
          border: 1px solid #ff8e5c;
          cursor: pointer;
        }
      }
    }
  }
  /deep/ .el-tabs {
    .el-tabs__header {
      margin: 0;
      border-bottom: none;
      width: 99%;
    }
    .el-tabs__item {
      color: #242424;
      border: none;
      font-size: 14px;
      text-align: left;
      padding-left: 38px;
    }
    .el-tabs__item.is-active {
      color: #dd6643;
      border: none;
    }
    .el-tabs__item:hover {
      color: #dd6643;
    }
    .el-tabs--card > .el-tabs__header .el-tabs__nav {
      border: none;
    }
    .el-tabs__nav-wrap::after {
      display: none;
    }
    .el-tabs__active-bar {
      background-color: #dd6643;
      height: 3px;
    }
  }
}
/deep/ .product-dialog {
  background: #eeeeee;
  .el-dialog__header,
  .el-dialog__body {
    padding: 0;
  }
}
/deep/ .cashier-dialog {
  .el-dialog__header,
  .el-dialog__body {
    padding: 0;
  }
  .el-dialog__headerbtn {
    top: 20px;
    z-index: 9999;
    .el-dialog__close {
      color: #fff;
    }
  }
}
</style>